//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const SortLight = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="SortLight"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.5868 6.18681C11.3687 6.40436 11.0146 6.40436 10.7964 6.18681L8.00121 3.38855L5.20359 6.18681C4.98541 6.40436 4.63135 6.40436 4.41317 6.18681C4.19561 5.96863 4.19561 5.61457 4.41317 5.39639L7.60479 2.20476C7.82297 1.98721 8.17703 1.98721 8.39521 2.20476L11.5868 5.39639C11.8044 5.61457 11.8044 5.96863 11.5868 6.18681ZM11.5868 9.81314C11.3687 9.59559 11.0146 9.59559 10.7964 9.81314L8.00121 12.6114L5.20359 9.81314C4.98541 9.59559 4.63135 9.59559 4.41317 9.81314C4.19561 10.0313 4.19561 10.3854 4.41317 10.6036L7.60479 13.7952C7.82297 14.0127 8.17703 14.0127 8.39521 13.7952L11.5868 10.6036C11.8044 10.3854 11.8044 10.0313 11.5868 9.81314Z"
            fill="currentColor"
          />
        </svg>
      }
      {...restProps}
    />
  );
};
